import { render, staticRenderFns } from "./ActionTitle.vue?vue&type=template&id=faa7c138&scoped=true"
import script from "./ActionTitle.vue?vue&type=script&lang=js"
export * from "./ActionTitle.vue?vue&type=script&lang=js"
import style0 from "./ActionTitle.vue?vue&type=style&index=0&id=faa7c138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa7c138",
  null
  
)

export default component.exports